const steps = [
  {
    number: '01',
    icon: 'ri-chat-heart-line',
    title: 'Share Your Vision',
    desc: 'Tell us about your event: the theme, mood, colours, and any ideas you have in mind. Nothing is too ambitious.',
  },
  {
    number: '02',
    icon: 'ri-draft-line',
    title: 'We Design & Plan',
    desc: 'Our styling team creates a detailed decor plan with mood boards, layouts, and full pricing for your approval.',
  },
  {
    number: '03',
    icon: 'ri-magic-2-line',
    title: 'We Set Up & Style',
    desc: 'We arrive early, handle every element of the setup, and ensure the space is perfect before your guests arrive.',
  },
];

export default function HowItWorks() {
  return (
    <section className="py-20 bg-white border-t border-gray-100">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-gray-900 mb-3">How It Works</h2>
          <p className="text-gray-500 text-base">
            A seamless process from your first idea to your perfect event space.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0">
          {steps.map((step, index) => (
            <div key={index} className="relative flex flex-col items-center text-center px-6">
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-1/2 w-full h-px bg-teal-100 z-0"></div>
              )}
              {/* Icon circle */}
              <div className="relative z-10 w-16 h-16 bg-teal-400 rounded-full flex items-center justify-center mb-5 flex-shrink-0">
                <i className={`${step.icon} text-2xl text-white`}></i>
              </div>
              <span className="text-teal-300 text-xs font-bold tracking-widest mb-1">
                STEP {step.number}
              </span>
              <h3 className="font-bold text-gray-900 text-lg mb-2">{step.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
